module.exports = __webpack_public_path__ + "static/media/F2.3e338b73.png";